<template>
    <div class="w-full m-auto flex flex-col my-4">
        <h2 class="text-center font-bold text-2xl" v-html="__('etape_'+etape.nom)"></h2>
        <p class="text-center" v-html="__('etape_'+etape.nom+'_chapeau')"></p>
        <template v-for="(option, vkey) in etape.options">
            <template v-if="showOption[etape.id][option.id]">
                <template v-if="option.type === 'button'">
                    <div>
                        <label v-if="__(option.name)" class="block text-center text-sm font-semibold text-gray-600 py-2"><span v-html="__(option.name)"></span> <sup v-if="option.est_requis && __(option.name)" class="text-red-600">*</sup></label>
                        <div class="flex">
                            <template v-for="(enfant) in option.enfants">
                                <div class="w-1/2 text-center mx-4">
                                    <button class="inline-block px-6 py-2 text-base
                                        font-medium leading-4 text-center text-white
                                        uppercase transition bg-cavilam-primary rounded
                                        shadow ripple hover:shadow-lg hover:bg-blue-800
                                        focus:outline-none"
                                        v-html="__(enfant.name)"
                                        @click="choisirOption(vkey, enfant.id)">
                                    </button>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
                <template v-else-if="option.type === 'text'">
                    <div class="text-xs my-2">
                        <label :for="'option_'+option.id" class="block text-center text-sm font-semibold text-gray-600 py-2"><span v-html="__(option.name)"></span> <sup v-if="option.est_requis && __(option.name)" class="text-red-600">*</sup></label>
                        <input :id="'option_'+option.id" v-model="form.etape[vkey].value" type="text" class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded-lg h-10 px-4">
                    </div>
                </template>
                <template v-else-if="option.type === 'label'">
                    <div class="text-xs my-2">
                        <label class="block text-center text-sm font-semibold text-gray-600 py-2" v-html="__(option.name)"></label>
                    </div>
                </template>
                <template v-else-if="option.type === 'textarea'">
                    <div class="text-xs my-2">
                        <label :for="'option_'+option.id" class="block text-center text-sm font-semibold text-gray-600 py-2"><span v-html="__(option.name)"></span> <sup v-if="option.est_requis && __(option.name)" class="text-red-600">*</sup></label>
                        <textarea :id="'option_'+option.id" v-model="form.etape[vkey].value" class="text-xs appearance-none block w-full text-grey-darker rounded-sm"></textarea>
                    </div>
                </template>
                <template v-else-if="option.type === 'date'">
                    <div class="text-xs my-2">
                        <label :for="'option_'+option.id" class="block text-center text-sm font-semibold text-gray-600 py-2"><span v-html="__(option.name)"></span> <sup v-if="option.est_requis && __(option.name)" class="text-red-600">*</sup></label>
                        <input :id="'option_'+option.id" v-model="form.etape[vkey].value" type="date" :name="option.name" class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded-lg h-10 px-4">
                    </div>
                </template>
                <template v-else-if="option.type === 'number'">
                    <div class="text-xs my-2">
                        <label :for="'option_'+option.id" class="block text-center text-sm font-semibold text-gray-600 py-2"><span v-html="__(option.name)"></span> <sup v-if="option.est_requis && __(option.name)" class="text-red-600">*</sup></label>
                        <input :id="'option_'+option.id" v-model.number="form.etape[vkey].value" type="number" :name="option.name" class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded-lg h-10 px-4">
                    </div>
                </template>
                <template v-else-if="option.type === 'checkbox'">
                    <div class="text-xs my-2">
                        <label class="block text-center text-sm font-semibold text-gray-600 py-2"><span v-html="__(option.name)"></span> <sup v-if="option.est_requis && __(option.name)" class="text-red-600">*</sup></label>
                        <div class="flex flex-col">
                            <template v-for="(enfant) in option.enfants">
                                <template v-if="enfant.type === 'label'">
                                    <label class="block text-center text-sm font-bold text-gray-600 py-2" v-html="__(enfant.name)"></label>
                                </template>
                                <template v-else>
                                    <label class="inline-flex mt-3 cursor-pointer">
                                        <input v-model="form.etape[vkey].value" :value="enfant.id" type="checkbox" class="form-checkbox h-5 w-5 text-cavilam-primary cursor-pointer">
                                        <span class="ml-2 text-gray-800" v-html="__(enfant.name)"></span>
                                    </label>
                                </template>
                            </template>
                        </div>
                    </div>
                </template>
                <template v-else-if="option.type === 'radio'">
                    <div class="text-xs my-2">
                        <label class="block text-sm font-semibold text-gray-600 py-2"><span v-html="__(option.name)"></span> <sup v-if="option.est_requis && __(option.name)" class="text-red-600">*</sup></label>
                        <div class="flex flex-col">
                            <template v-for="(enfant) in option.enfants">
                                <template v-if="enfant.type === 'label'">
                                    <label class="block text-sm font-bold text-gray-600 py-2" v-html="__(enfant.name)"></label>
                                </template>
                                <template v-else>
                                    <label class="inline-flex mt-3 cursor-pointer" v-if="enfant.est_actif === 1">
                                        <input v-model="form.etape[vkey].value" :value="enfant.id" type="radio" class="form-radio h-5 w-5 text-cavilam-primary cursor-pointer">
                                        <span class="ml-2 text-gray-800" v-html="__(enfant.name).replace('__TARIF__', parseFloat(enfant.montant).toFixed(0))"></span>
                                    </label>
                                </template>
                            </template>
                        </div>
                    </div>
                </template>
                <template v-else-if="option.type === 'select'">
                    <div class="text-xs my-2">
                        <label :for="'option_'+option.id" class="block text-center text-sm font-semibold text-gray-600 py-2"><span v-html="__(option.name)"></span> <sup v-if="option.est_requis && __(option.name)" class="text-red-600">*</sup></label>
                        <select :id="'option_'+option.id" v-model="form.etape[vkey].value" class="block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded-lg h-10 px-4 md:w-full">
                            <option :value="null" disabled>{{ __('choisir...') }}</option>
                            <template v-for="(enfant) in option.enfants">
                                <option :value="enfant.id" v-html="__(enfant.name)"></option>
                            </template>
                        </select>
                    </div>
                </template>
            </template>
        </template>
    </div>
</template>


<script>
export default {
    name: "Etape",
    props: {
        etape: Object,
    },
    data: function () {
        return {
            form: {
                etape: [],
            },
            showError: false,
        }
    },
    created() {
        for(let option in this.etape.options) {
            this.form.etape = [];
            this.form.etape.push(this.etape.options[option]);
            if(this.form.etape[option].type === 'checkbox')
                this.form.etape[option].value = [];
        }
    },
    methods: {
        choisirOption(optionParentIndex, idOptionEnfant) {
            this.form.etape[optionParentIndex].value = idOptionEnfant;
        },
        comparerExpression(expression, condition1) {
            if(!expression || !condition1)
                return false;

            expression = expression.split(':');
            if(expression && expression.length === 2) {
                let condition2;

                // Alors c'est une date, sinon c'est une valeur quelconque
                if(expression[1].includes('NOW')) {
                    let jours = expression[1].match(/[+-]*[0-9]+/g);
                    if(jours && jours.length)
                        jours = parseInt(jours[0]);
                    else
                        jours = 0;
                    condition2 = (new Date()).setDate((new Date()).getDate() + jours);
                    condition1 = (new Date(condition1)).getTime();
                } else {
                    condition2 = expression[1];
                }

                switch (expression[0]) {
                    case 'GREATER':
                        return (condition1 > condition2);
                    case 'LOWER':
                        return (condition1 < condition2);
                    case 'GREATER_EQUAL':
                        return (condition1 >= condition2);
                    case 'LOWER_EQUAL':
                        return (condition1 <= condition2);
                    default:
                        return (condition1 === condition2);
                }
            }

            return false;
        },
    },
    computed: {
        showOption() {
            let displayOption = {};

            displayOption[this.etape.id] = {};
            for(let optionIndex in this.etape.options) {
                let option = this.etape.options[optionIndex];
                displayOption[this.etape.id][option.id] = true;
                for(let row in option.conditions) {
                    let condition = option.conditions[row];
                    let parentOption = this.form.etape.find(option => {
                        return option.id === condition.parent_option_id;
                    });

                    if(!this.form.etape || !parentOption ||
                        (
                            !this.comparerExpression(condition.expression, parentOption.value) &&
                            parseInt(parentOption.value) !== parseInt(condition.enfant_option_id)
                        )
                    ) {
                        displayOption[this.etape.id][option.id] = false;
                        option.value = null;
                        break;
                    }
                }
            }
            return displayOption;
        },
    }
}
</script>